var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AssistantFun',{attrs:{"type":"type"}}),(_vm.type!=3)?_c('AssistantInstation',{attrs:{"type":_vm.type}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }